/** Outer page frame for Home, Blog Library, Blog Post, and How it Works. */
export const APP_WIDE_PAGE_FRAME_CLASS =
  "min-h-[calc(100vh-7rem)] px-4 pb-20 pt-8 sm:px-6 lg:px-[70px] xl:px-[100px]";

/** Inner content width: wider than legal pages (max-w-3xl), inset from full-bleed app pages. */
export const APP_WIDE_PAGE_CONTENT_CLASS = "mx-auto w-full max-w-6xl";
